module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b4b0b568e40b4296d473ed4906cb9fd7.png";